import React, { FunctionComponent, useState } from 'react';

import { PictureProps } from 'src/components/picture';

import {
  StyledContainer,
  StyledImageContainer,
  StyledImage,
  StyledArrowColumn,
  StyledArrowLeft,
  StyledArrowRight,
  StyledNavigationItem,
  StyledNavigationRow,
  StyledImageWrapper,
} from './images-slider.styled';

interface Props {
  images: PictureProps[];
}

export const ImagesSlider: FunctionComponent<Props> = (props) => {
  const [selectedItem, setSelectedItem] = useState(0);
  const { images, ...rest } = props;

  const handleSelectPrevious = (): void => setSelectedItem((previousState) => previousState - 1);
  const handleSelectNext = (): void => setSelectedItem((previousState) => previousState + 1);

  return (
    <StyledContainer {...rest}>
      <StyledArrowColumn>{selectedItem !== 0 && <StyledArrowLeft onClick={handleSelectPrevious} />}</StyledArrowColumn>
      <StyledImageContainer>
        <StyledImageWrapper>
          <StyledImage {...images[selectedItem]} />
        </StyledImageWrapper>
        <StyledNavigationRow>
          {images.map((image, index) => (
            <StyledNavigationItem key={index} $active={index === selectedItem} onClick={() => setSelectedItem(index)} />
          ))}
        </StyledNavigationRow>
      </StyledImageContainer>
      <StyledArrowColumn>
        {images.length - 1 !== selectedItem && <StyledArrowRight onClick={handleSelectNext} />}
      </StyledArrowColumn>
    </StyledContainer>
  );
};
